import React, { useState, useEffect, useRef } from 'react';

const SearchBar = ({ containerSelector = 'body' }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInput = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value.trim().length === 0) {
      setResults([]);
      return;
    }

    const lowerQuery = value.toLowerCase();
    const matches = [];

    const searchRoot = document.querySelector(containerSelector);
    if (!searchRoot) return;

    const elements = Array.from(searchRoot.querySelectorAll('*'));

    elements.forEach((el) => {
      const tag = el.tagName.toLowerCase();
      const text = el.textContent.trim();

      if (
        text &&
        text.toLowerCase().includes(lowerQuery) &&
        text.length > 5 &&
        !matches.some((m) => m.text === text)
      ) {
        matches.push({
          element: el,
          text,
          tag,
        });
      }
    });

    setResults(matches.slice(0, 20));
    setShowResults(true);
  };

  const handleSuggestionClick = (el) => {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.style.outline = '1px solid #e60000';
    setTimeout(() => (el.style.outline = ''), 2000);
    setShowResults(false);
  };

  return (
  <div style={{ position: 'relative', width: '100%' }} ref={containerRef}>
    {/* Input wrapper with icon */}
    <div style={{ position: 'relative' }}>
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: '10px',
          transform: 'translateY(-50%)',
          fontSize: '16px',
          color: '#999',
          pointerEvents: 'none',
        }}
      >
        <svg width="22" height="22" fill="#999" viewBox="0 0 24 24">
  <path d="M10 2a8 8 0 015.292 13.708l4.5 4.5-1.414 1.414-4.5-4.5A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z"/>
</svg>

      </span>

      <input
        type="text"
        value={query}
        onChange={handleInput}
        placeholder="Search..."
        style={{
          width: '100%',
          padding: '10px 10px 10px 32px', // left padding to accommodate icon
          fontSize: '16px',
          borderColor: '#E6EAEE ',
        }}
        onFocus={() => query && results.length > 0 && setShowResults(true)}
      />
    </div>

    {showResults && results.length > 0 && (
      <div
        style={{
          position: 'absolute',
          top: '42px',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #ccc',
          maxHeight: '250px',
          overflowY: 'auto',
          zIndex: 1000,
          boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
          whiteSpace: 'pre-wrap',
        }}
      >
        {results.map((res, i) => (
          <div
            key={i}
            onClick={() => handleSuggestionClick(res.element)}
            style={{
              padding: '8px 12px',
              cursor: 'pointer',
            }}
            dangerouslySetInnerHTML={{
              __html: formatResultText(res.text, query),
            }}
          />
        ))}
      </div>
    )}

    {showResults && results.length === 0 && (
      <div
        style={{
          position: 'absolute',
          top: '42px',
          left: 0,
          right: 0,
          background: '#fff',
          border: '1px solid #ccc',
          padding: '10px',
          zIndex: 1000,
        }}
      >
        No matching content found.
      </div>
    )}
  </div>
);

};

// ✅ Format result text for highlight and dividers
function formatResultText(text, query) {
  const escapedQuery = query.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const highlighted = text.replace(regex, '<mark>$1</mark>');

  // Force line breaks and <hr> after common block elements
  return `${highlighted}<hr style="margin: 5px 0;"/>`;
}

export default SearchBar;
